import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { SelectionList } from '@dixa/lib-shared-habla';
import Fuse from 'fuse.js';
import { useMemo } from 'react';
import { languageCodesToSelectionListValue, } from 'utils/useLanguageSelectionList';
const minMatchCharLength = 2;
/**
 * Creates list of SelectionList Items and Dividers based on the language
 * preferences. This helps us share SelectionList items across different types
 * of selection lists (e.g. SelectionList and InputSelectionList).
 */
export const useLanguageSelectionListItems = (props) => {
    const { revertLabel = 'Show original message', sortFn = (a, b) => a.name.localeCompare(b.name), searchTerm, recentlyUsedLanguagesCodes, languages, showRevert, } = props;
    const recentlyUsedLanguages = useMemo(() => languageCodesToSelectionListValue(recentlyUsedLanguagesCodes !== null && recentlyUsedLanguagesCodes !== void 0 ? recentlyUsedLanguagesCodes : []), [recentlyUsedLanguagesCodes]);
    const recentlyUsedItems = useMemo(() => searchTerm || !recentlyUsedLanguages.length ? undefined : (_jsxs(_Fragment, { children: [_jsx(SelectionList.Divider, { label: "Recently used languages" }), recentlyUsedLanguages.map((recentlyUsedLanguage) => (_jsx(SelectionList.Item, Object.assign({ value: recentlyUsedLanguage }, { children: recentlyUsedLanguage.name }), `recentlyUsed-${recentlyUsedLanguage.code}`))), _jsx(SelectionList.Divider, { label: "All languages" })] })), [recentlyUsedLanguages, searchTerm]);
    const sortedLanguages = useMemo(() => [...languages].sort(sortFn), [languages, sortFn]);
    const filteredLanguages = useMemo(() => {
        const fuse = new Fuse(sortedLanguages, {
            keys: ['name'],
            threshold: 0.2,
            minMatchCharLength,
            distance: 200,
        });
        if (searchTerm.length >= minMatchCharLength) {
            const fuseResults = fuse.search(searchTerm).map(({ item }) => item);
            return fuseResults.length > 0 ? fuseResults : sortedLanguages;
        }
        return sortedLanguages;
    }, [searchTerm, sortedLanguages]);
    const allItems = useMemo(() => filteredLanguages.map((language) => (_jsx(SelectionList.Item, Object.assign({ value: language }, { children: language.name }), `all-${language.code}`))), [filteredLanguages]);
    return (_jsxs(_Fragment, { children: [showRevert && (_jsx(SelectionList.Item, Object.assign({ value: "revert" }, { children: revertLabel }))), recentlyUsedItems, allItems] }));
};
